import { Container, Navbar } from "react-bootstrap";
import Brand from "./brand/Brand";
import LoggedInMenu from "./menus/LoggedInMenu";
import { useAuthContext } from "../auth/AuthContext";
import LoggedOutMenu from "./menus/LoggedOutMenu";

const Header = () => {
  const { user } = useAuthContext();

  return (
    <Navbar expand="lg" bg="primary">
      <Container fluid>
        <Brand />
        {user ?
          <LoggedInMenu />
        : <LoggedOutMenu />}
      </Container>
    </Navbar>
  );
};

export default Header;
